import {useCallback} from 'react';
import {APP_VERSION as versionInfo, FEEDBACK_EMAIL as feedback} from 'env';
import {STORAGE_STATE_KEY as storageKey} from 'shared/const';
import {uniqueString} from 'shared/utils/uniqueString';
import {whichBrowser} from 'ui/effects/whichBrowser';
import {inspectable} from 'ui/utils/core';
import {storageProxy} from 'interactors';

interface Dependencies {
  json?: JSON;
  wndw?: Window;
}

export function useMailFeedback(di: Dependencies = {}): () => void {
  const {json = JSON, wndw = window} = di;

  return useCallback(() => {
    const lineBreak = '%0D%0A';
    const delimiter = lineBreak + lineBreak;

    const eventId = uniqueString();
    const browserInfo = whichBrowser();
    const storageInfo = json.stringify(inspectable(storageProxy.getItem(storageKey)));
    const systemInfo = versionInfo + lineBreak + browserInfo + lineBreak + storageInfo;

    const address = `mailto:${feedback}`;
    const subject = `Ошибка в Тяжеловато #${eventId}`;
    const sendData = [
      'Пожалуйста, опишите проблему, с которой столкнулись:',
      delimiter,
      delimiter,
      'Информация о системе и работе с приложением — не стирайте её:',
      delimiter,
      systemInfo,
    ].join('');

    wndw.location.href = `${address}?subject=${subject}&body=${sendData}`;
  }, [json, wndw.location]);
}
